<!-- filepath: /Volumes/Data Partition/veins-freela/VeinsEnergia-api/assets/modules/new-panorama/components/render-panorama-status-cell.vue -->
<template>
  <div
    v-if="qty"
    style="display: flex; align-items: center; justify-content: end;"
  >
    <span style="width: 80px;">
      <RenderMoneyColumnValue :value="value" :max-fraction-digits="0" /> R$
    </span>
    <span style="padding: 0 5px;">|</span>
    <span style="width: 30px;"> {{ qty }} # </span>
    <span style="padding: 0 5px;">|</span>
    <span style="width: 80px;">
      <RenderMoneyColumnValue :value="value / qty" :max-fraction-digits="0" />
      TM
    </span>
    <span style="padding: 0 5px;">|</span>
    <span style="width: 50px;">
      <RenderPercentageColumnValue :value="percent" />
      H
    </span>
  </div>
</template>

<script>
import {
  RenderMoneyColumnValue,
  RenderPercentageColumnValue,
} from '../../../ui/render';

export default {
  components: {
    RenderMoneyColumnValue,
    RenderPercentageColumnValue,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    qty: {
      type: Number,
      default: 0,
    },
    percent: {
      type: Number,
      default: 0,
    },
  },
};
</script>
